import { Check } from "lucide-react";

const Timeline = ({ trackingData }) => {

    return (
        <div className="timeline">

            {trackingData.map((step, index) => (

                <div key={index} className={`timeline-step ${step.type} ${step.status}`}>

                    <div className="dot">
                        {step.type === "major" && step.status === "done" && (
                            <Check size={28} />
                        )}
                    </div>

                    <div className="line" />

                    <div className="content">
                        <p>{step.label}</p>
                        {step.time && <span>{step.time}</span>}
                    </div>

                </div>

            ))}

        </div>
    );
};

export default Timeline;